import { render, staticRenderFns } from "./CompraShowData.vue?vue&type=template&id=7c75afa4"
import script from "./CompraShowData.vue?vue&type=script&lang=js"
export * from "./CompraShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports